import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
const GlobalComponents = {
    install(Vue) {
        Vue.component('DatePicker', DatePicker);
    }
};
export default GlobalComponents;
